import React from "react";

import { LoginForm } from "../components";

export const Login: React.FC = () => {
  return <LoginForm />;
};
